import { Component, EventEmitter, Input, Output, TemplateRef } from "@angular/core";

import { MedOptionType } from "../types";

@Component({
  selector: "med-multiselect-item",
  templateUrl: "./med-multiselect-item.component.html",
  styleUrls: ["./med-multiselect-item.component.scss"],
})
export class MedMultiselectItemComponent {
  @Input() option!: MedOptionType<any>;
  @Input() disabled?: boolean;
  @Input() template: TemplateRef<any> | undefined;
  @Input() checkIconTemplate: TemplateRef<any> | undefined;
  @Input() selected: boolean | undefined;

  @Output() onClick: EventEmitter<any> = new EventEmitter();
  @Output() onKeydown: EventEmitter<any> = new EventEmitter();

  onOptionClick(event: Event) {
    if (this.disabled || this.option.disabled) {
      return;
    }

    this.onClick.emit({
      originalEvent: event,
      option: this.option,
    });
  }
}
